// vue babel plugin doesn't support pragma replacement
import { mdx } from '@mdx-js/vue'
let h;
/* @jsx mdx */
import AtriumVideo from '@/components/AtriumVideo.vue'
import ConferenceOver from '@/components/ConferenceOver.vue'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ConferenceOver mdxType="ConferenceOver" />
    <hr></hr>
    <p>{`Nuestro informe de la cumbre ya ha sido publicado: `}<a parentName="p" {...{
        "href": "https://edit.climate.red/uploads/2020-climate-red-summit-report-sp-copy.pdf"
      }}>{`¡Haga clic aquí para ver y descargar!`}</a></p>
    <hr></hr>
    <p><strong parentName="p">{`El cambio climático afecta a todos, en todas partes - por lo tanto, ninguna persona, país o zona horaria está excluida de la cumbre virtual Climate:Red, organizada por la red de la Federación Internacional de la Cruz Roja y de la Media Luna Roja y abierta para que todos participen.`}</strong></p>
    <p>{`Al reunir a personas de todo el mundo, creamos una plataforma verdaderamente global para debatir e inspirar la acción climática.`}</p>
    <p>{`La cumbre presenta más de `}<strong parentName="p">{`200 sesiones interesantes`}</strong>{` para que elijas. Una semana antes de la cumbre, puede comenzar a navegar por el programa y crear su propio horario del 9 al 10 de septiembre.`}</p>
    <p>{`Durante la cumbre, puedes:`}</p>
    <ul>
      <li parentName="ul">{`Escuchar nuestra fascinante gama de oradores, desde ministros hasta científicos, pasando por directores generales y personas de comunidades remotas que impulsan iniciativas sobre el cambio climático todos los días;`}</li>
      <li parentName="ul">{`Escuchar las ideas innovadoras y los proyectos climáticos en nuestras carpas de innovación y votar por sus favoritos para ganar;`}</li>
      <li parentName="ul">{`debatir soluciones con otros profesionales, activistas, investigadores y responsables de la toma de decisiones que trabajan por el clima;`}</li>
      <li parentName="ul">{`conocer a personas de todo el mundo en charlas virtuales de café al azar;`}</li>
      <li parentName="ul">{`hacer visitas virtuales a proyectos climáticos, jugar a juegos climáticos en tiempo real... ¡y mucho más!`}</li>
    </ul>
    <hr></hr>
    <p>{`Después de registrarse e ingresar,Consulte también la sección “Qué hay ahora “ para ver algunas sesiones interesantes y oradores inspiradores.Una semana antes de la cumbre, puede comenzar a navegar por el programa y crear su propio horario del 9 al 10 de septiembre.`}</p>
    <p>{`La conferencia tiene la finalidad de servir a conectarse, inspirarse mutuamente, aprender juntos y construir nuevas ideas e iniciativas. En Climate:Red podrás hacer precisamente eso.`}</p>
    <p>{`No podemos esperar para conocerte!`}</p>
    <AtriumVideo mdxType="AtriumVideo" />
    <p>{`Puede leer más sobre la visión colectiva de la red de la Cruz Roja y de la Media Luna Roja para abordar el cambio climático como una emergencia humanitaria en nuestra `}<a parentName="p" {...{
        "href": "https://future-rcrc.com/strategy-2030/"
      }}>{`Estrategia 2030`}</a>{` y `}<a parentName="p" {...{
        "href": "https://media.ifrc.org/ifrc/wp-content/uploads/sites/5/2020/02/Movement-Climate-Ambitions-2020-final.pdf"
      }}>{`las Ambiciones del Movimiento para Abordar la Crisis Climática`}</a>{`. Nuestro `}<a parentName="p" {...{
        "href": "https://www.climatecentre.org/training/"
      }}>{`Kit de Capacitación sobre el Clima también`}</a>{` podría ser un recurso útil para usted.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export default {
  name: 'Mdx',
  inject: {
    $mdxComponents: {
      default: () => () => ({})
    }
  },
  computed: {
    components() {
      return this.$mdxComponents()
    }
  },
  render(createElement) {
    h = mdx.bind({ createElement, components: this.components })
    return MDXContent({ components: this.components })
  }
}
   